// extracted by mini-css-extract-plugin
module.exports = {"container":"TabList_container__C7_H9"};